module.exports = __webpack_public_path__ + "img/arrow-curve.0dfd2302.png";